import ChemiNovaEntityType from "../model/enums/ChemiNovaEntityType";

function chemiNovaEntityTypeDisplay(
  entity_type: ChemiNovaEntityType | undefined,
  extended: boolean
): string {
  switch (entity_type) {
    case ChemiNovaEntityType.SITE:
      return "Collection/Enseble";
    case ChemiNovaEntityType.CHELEMENT:
      return extended ? "Cultural Heritage Asset" : "CH Asset";
    case ChemiNovaEntityType.E3DMODEL:
      return "Condition Assessment / e3D model";
    case ChemiNovaEntityType._3DINSTANCE:
      return "3D Scan";
    case ChemiNovaEntityType.ANNOTATION:
      return "Annotation";
    case ChemiNovaEntityType.TEXTURE_LAYER:
      return "Texture";
    case ChemiNovaEntityType.SEARCH:
      return "Back to";
    case ChemiNovaEntityType.COLLECTION:
      return "Collection";
    case ChemiNovaEntityType.MY_LIST:
      return "My List";
  }
  return "";
}

export default chemiNovaEntityTypeDisplay;
